import globalConfig from "../utiles/globalConfig";
import { SHOW_NOTICE } from "../store/web/h5";

export default {
  data() {
    return {
      extraCoinDownContent:
        "尊敬するプレイヤーの皆様：\n\nプレミアムセンターの優待券配布戦略の評価に基づき、以下の調整を行うことになりました:\n\n2025年11月6日17:00 (utc+9) より、優待券の配布を停止いたします。\n\nそのため、ポイントショップで交換可能なアイテムの種類を増やし、より良い交換体験を提供できるよう努めてまいります。\n\nなお、2025年11月6日17:00 (utc+9) 以前に受け取られた優待券は、その有効期限まで引き続きご利用いただけます。\n\nさらに、2025年11月6日17:00 (utc+9) より、チャージイベントに以下の調整を行います：\n1.プレミアムセンターのチャージミッションは、アプリ内課金（App StoreおよびGoogle Playストア経由）でのみ参加可能となります。\n2.現行の公式イベント「合計チャージ額で報酬GET」は終了し、ゲーム内に新たなイベントが登場します。毎日指定の金額をアプリ内でチャージすることで、豪華なゲームアイテムを受け取ることができます。\n\n今回の調整によりご不便をおかけすることを深くお詫び申し上げます。プレイヤーの皆様の変わらぬご支援とご理解に心より感謝申し上げます。",
    };
  },
  methods: {
    // 检查是否在展示时间范围内
    isInDisplayPeriod(startTime, endTime) {
      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);
      return now >= startDate && now <= endDate;
    },
    // 获取当前UTC日期字符串 (YYYY-MM-DD)
    getCurrentUTCDateString() {
      const now = new Date();
      return now.toISOString().split("T")[0];
    },
    // 检查今天是否已经弹出过
    hasShownToday(cookieName) {
      const today = this.getCurrentUTCDateString();
      const lastShownDate = globalConfig.getCookie(cookieName);
      return lastShownDate === today;
    },
    // 检查是否应该显示弹窗（每日一次，总共最多3次）
    shouldShowPopupWithLimit(
      startTime,
      endTime,
      dateCookieName,
      countCookieName,
      maxCount = 3
    ) {
      // 1. 检查是否在展示时间范围内
      if (!this.isInDisplayPeriod(startTime, endTime)) {
        return false;
      }

      // 2. 检查今天是否已经弹出过
      if (this.hasShownToday(dateCookieName)) {
        return false;
      }

      // 3. 检查总弹出次数是否达到上限
      const totalCount = parseInt(
        globalConfig.getCookie(countCookieName) || "0"
      );
      if (totalCount >= maxCount) {
        return false;
      }

      return true;
    },
    // 记录今天已经弹出
    markAsShownToday(cookieName) {
      const today = this.getCurrentUTCDateString();
      globalConfig.setCookie(cookieName, today);
    },
    // 记录弹出并增加计数
    markAsShownTodayWithCount(dateCookieName, countCookieName) {
      // 记录今天已弹出
      this.markAsShownToday(dateCookieName);

      // 增加总计数
      const currentCount = parseInt(
        globalConfig.getCookie(countCookieName) || "0"
      );
      globalConfig.setCookie(countCookieName, (currentCount + 1).toString());
    },
    showTipPopupEntry() {
      try {
        // 如果是mobage和dmm平台就不要弹窗
        const curHref = window.location.href;
        const isDmm =
          curHref.indexOf("transaction_id=") !== -1 &&
          curHref.indexOf("h=") !== -1;
        const isMobage = !!globalConfig.getHrefParamUndecode("fromMobage");
        if (isDmm || isMobage) {
          return;
        }

        this.jpExtraCoinDownTip();
      } catch (e) {
        console.error(e);
      }
    },
    jpExtraCoinDownTip() {
      if (
        this.isInDisplayPeriod(
          "2025-10-30T17:00:00+08:00",
          "2025-11-13T23:59:59+08:00"
        ) &&
        [2].includes(Number(window.gameId))
      ) {
        if (
          this.isInDisplayPeriod(
            "2025-10-30T17:00:00+08:00",
            "2025-11-06T23:59:59+08:00"
          )
        ) {
          this.$store.commit(SHOW_NOTICE, this.extraCoinDownContent);
        } else {
          const dateCookieName = `jp_game_coupon_down_${window.gameId}_mark`;
          const countCookieName = `jp_game_coupon_down_${window.gameId}_count`;
          if (
            this.shouldShowPopupWithLimit(
              "2025-11-07T00:00:00+08:00",
              "2025-11-13T23:59:59+08:00",
              dateCookieName,
              countCookieName,
              7
            )
          ) {
            this.$store.commit(SHOW_NOTICE, this.extraCoinDownContent);
            this.markAsShownTodayWithCount(dateCookieName, countCookieName);
          }
        }
      }
    },
  },
};
